import { render, staticRenderFns } from "./poste-a-verser-tab-item.vue?vue&type=template&id=999a48f6&scoped=true"
import script from "./poste-a-verser-tab-item.vue?vue&type=script&setup=true&lang=js"
export * from "./poste-a-verser-tab-item.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999a48f6",
  null
  
)

export default component.exports